import { Component, OnInit,Input } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { CartItem } from 'src/app/modals/cart-item';
import { ProductService } from '../../shared/services/product.service';
import { CartService } from '../../shared/services/cart.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { slide } from '../../shared/services/slide.service';
import { slider } from '../../../modals/slider.model';
import {SwiperConfigInterface,SwiperPaginationInterface} from "ngx-swiper-wrapper";
import{ AdsService } from '../../shared/services/ads.service'
import { Ad } from '../../../modals/ad.model';
import { InfoService } from '../../shared/services/info.service'
import { Info } from '../../../modals/info.model'
@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrls: ['./home-three.component.scss']
})
export class HomeThreeComponent implements OnInit {
  public config: SwiperConfigInterface = {};

  private pagination: SwiperPaginationInterface = {
    el: ".swiper-pagination",
    clickable: true,
  };

  products: Product[];
  productsNovi: Product[];
  productsTop:Product[];
  public banners = [];

  shoppingCartItems: CartItem[] = [];
  wishlistItems  :   Product[] = [];
  contentLoaded = false;

  public featuredProducts: Array<Product>;
  public onSaleProducts: Array<Product>;
  public topRatedProducts: Array<Product>;
  public newArrivalsProducts: Array<Product>;
  isMobile = false;
  ads:Ad[]=[];
  infos: Info | null = null;
  public discount: { image: string; title: string; subtitle: string }[] = [];

  constructor(private productService: ProductService, private cartService: CartService,private http:HttpClient, private _slide:slide, private adsService:AdsService, private infoService:InfoService) {
    
   }

  ngOnInit() {
    
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
    this.infoService.getInfo().subscribe((info: Info) => {
      this.infos = info;
    });
  
    this.adsService.getAdsData().subscribe((response) => {
      this.ads = response;
      
      this.discount = this.ads.map(ad => ({
        image: `https://weberp-api.com/images/${ad.SlikaPath}`, 
        title: ad.Tekst,
        subtitle: ad.Opis
      }));
    });
    this.productService.getProducts().subscribe((product) => {
      this.products = product;
    });
    this.productService.getTopProducts().subscribe((product) => {
      this.productsTop = product;
    });
    this.productService.getNoviProducts().subscribe((product) => {
      this.productsNovi = product;
    });
    setTimeout(() => {
      this.contentLoaded = true;
    }, 3000);
    
//console.log('majko moja',this.infos?.telefon);
  }
  
}
